"use client";

import { Button } from "@radix-ui/themes";

export default function BackToTop() {
    return (
        <Button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="fixed bottom-14 right-3 bg-att-cobalt-blue text-white p-2 rounded-[4px] hover:cursor-pointer">
            Back to top
        </Button>
    );
}
